import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {
  Box,
  Grid,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  TextField,
} from '@mui/material';
import {
  Selection,
  TextInput,
  FileUpload,
  ComboBox,
  FileUploadContract,
  ArrayInput,
  NumberFormatCustom,
} from 'components';

import { styled } from '@mui/material/styles';
import ApiServices from 'services';
import Utils from 'commons/utils';

export const TabGeneralInfo = ({
  clientCareHistoryItem,
  clientInformationDetail,
  value,
  setValue,
  getClientCareHistoryDetails,
}) => {
  const [code, setCoCode] = useState('');
  const [name, setName] = useState('');
  const [taxCode, setTaxCode] = useState('');
  const [arrAddress, setArrAddress] = useState([]);
  const [arrPhone, setArrPhone] = useState([]);
  const [arrFax, setArrFax] = useState([]);
  const [cargotype, setCargotype] = useState('');
  const [representer, setRepresenter] = useState('');
  const [birthdayRepresenter, setBirthdayRepresenter] = useState('');
  const [emailRepresenter, setEmailRepresenter] = useState('');
  const [phoneRepresenter, setPhoneRepresenter] = useState('');
  const [requirement, setRequirement] = useState('');
  const [budget, setBudget] = useState('');
  const [goLiveDate, setGoLiveDate] = useState('');
  const [isPaymentCompleted, setIsPaymentCompleted] = useState(false);
  const [note, setNote] = useState('');
  const [email, setEmail] = useState('');

  const [hasUpdate, setHasUpdate] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (clientInformationDetail?.code) {
      setCoCode(clientInformationDetail?.code);
    }
    if (clientInformationDetail?.name) {
      setName(clientInformationDetail?.name);
    }
    if (clientInformationDetail?.tax_Code) {
      setTaxCode(clientInformationDetail?.tax_Code);
    }
    if (clientInformationDetail?.arrAddress) {
      setArrAddress(clientInformationDetail?.arrAddress);
    }
    if (clientInformationDetail?.arrNumberPhone) {
      setArrPhone(clientInformationDetail?.arrNumberPhone);
    }
    if (clientInformationDetail?.arrFax) {
      setArrFax(clientInformationDetail?.arrFax);
    }
    if (clientInformationDetail?.cargotype) {
      setCargotype(clientInformationDetail?.cargotype);
    }
    if (clientInformationDetail?.representer) {
      setRepresenter(clientInformationDetail?.representer);
    }
    if (clientInformationDetail?.birthdayRepresenter) {
      setBirthdayRepresenter(
        clientInformationDetail?.birthdayRepresenter
          ? Utils.convertToDateFormat_New(clientInformationDetail?.birthdayRepresenter)
          : null,
      );
    }
    if (clientInformationDetail?.emailRepresenter) {
      setEmailRepresenter(clientInformationDetail?.emailRepresenter);
    }
    if (clientInformationDetail?.phoneRepresenter) {
      setPhoneRepresenter(clientInformationDetail?.phoneRepresenter);
    }
    if (clientInformationDetail?.requirement) {
      setRequirement(clientInformationDetail?.requirement);
    }
    if (clientInformationDetail?.budget) {
      setBudget(clientInformationDetail?.budget);
    }
    if (clientInformationDetail?.goLiveDate) {
      setGoLiveDate(
        Utils.checkIsDate(clientInformationDetail?.goLiveDate)
          ? Utils.convertToDateFormat(clientInformationDetail?.goLiveDate)
          : null,
      );
    }
    if (clientInformationDetail?.isPaymentCompleted) {
      setIsPaymentCompleted(clientInformationDetail?.isPaymentCompleted);
    }
    if (clientInformationDetail?.note) {
      setNote(clientInformationDetail?.note);
    }
    if (clientInformationDetail?.email) {
      setEmail(clientInformationDetail?.email);
    }
  }, [clientInformationDetail]);

  const handleUpdate = async () => {
    const dataSend = {
      id: clientInformationDetail.id,
      code,
      name,
      tax_Code: taxCode,
      arrAddress,
      arrNumberPhone: arrPhone,
      arrFax,
      cargotype,
      representer,
      birthdayRepresenter: birthdayRepresenter ? birthdayRepresenter : null,
      emailRepresenter,
      phoneRepresenter,
      requirement,
      budget: budget ? +budget : 0,
      goLiveDate: goLiveDate ? goLiveDate : null,
      isPaymentCompleted,
      note,
      arrServiceId: clientInformationDetail?.arrServiceId || [],
      email,
    };

    setLoading(true);
    try {
      const { data } = await ApiServices.updateClientCompany(clientInformationDetail.id, dataSend);
      if (data) {
        window.UIMessage?.success('Cập nhật thành công');
        getClientCareHistoryDetails(clientCareHistoryItem?.id);
        setHasUpdate(false);
      } else {
        window.UIMessage?.error('Cập nhật thất bại !!!');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleCancelUpdate = () => {
    setHasUpdate(false);
    setCoCode(clientInformationDetail?.code || '');
    setName(clientInformationDetail?.name || '');
    setTaxCode(clientInformationDetail?.tax_Code || '');
    setArrAddress(clientInformationDetail?.arrAddress || []);
    setArrPhone(clientInformationDetail?.arrNumberPhone || []);
    setArrFax(clientInformationDetail?.arrFax || []);
    setCargotype(clientInformationDetail?.cargotype || '');
    setRepresenter(clientInformationDetail?.representer || '');
    setBirthdayRepresenter(clientInformationDetail?.birthdayRepresenter || '');
    setEmailRepresenter(clientInformationDetail?.emailRepresenter || '');
    setPhoneRepresenter(clientInformationDetail?.phoneRepresenter || '');
    setRequirement(clientInformationDetail?.requirement || '');
    setBudget(clientInformationDetail?.budget || '');
    setGoLiveDate(clientInformationDetail?.goLiveDate || '');
    setIsPaymentCompleted(clientInformationDetail?.isPaymentCompleted || false);
    setNote(clientInformationDetail?.note || '');
    setEmail(clientInformationDetail?.email || '');
  };

  const handleChangeCode = useCallback(
    (e) => {
      setHasUpdate(true);
      setCoCode(e.target.value);
    },
    [code],
  );
  const handleChangeName = useCallback(
    (e) => {
      setHasUpdate(true);
      setName(e.target.value);
    },
    [name],
  );
  const handleChangeTaxCode = useCallback(
    (e) => {
      setHasUpdate(true);
      setTaxCode(e.target.value);
    },
    [taxCode],
  );
  const handleChangeArrAddress = useCallback(
    (e) => {
      setHasUpdate(true);
      setArrAddress(e.target.value);
    },
    [arrAddress],
  );
  const handleChangeArrPhone = useCallback(
    (e) => {
      setHasUpdate(true);
      setArrPhone(e.target.value);
    },
    [arrPhone],
  );
  const handleChangeArrFax = useCallback(
    (e) => {
      setHasUpdate(true);
      setArrFax(e.target.value);
    },
    [arrFax],
  );
  const handleChangeCargotype = useCallback(
    (e) => {
      setHasUpdate(true);
      setCargotype(e.target.value);
    },
    [cargotype],
  );
  const handleChangeRepresenter = useCallback(
    (e) => {
      setHasUpdate(true);
      setRepresenter(e.target.value);
    },
    [representer],
  );
  const handleChangeBirthdayRepresenter = useCallback(
    (e) => {
      setHasUpdate(true);
      setBirthdayRepresenter(e.target.value);
    },
    [birthdayRepresenter],
  );
  const handleChangeEmailRepresenter = useCallback(
    (e) => {
      setHasUpdate(true);
      setEmailRepresenter(e.target.value);
    },
    [emailRepresenter],
  );
  const handleChangePhoneRepresenter = useCallback(
    (e) => {
      setHasUpdate(true);
      setPhoneRepresenter(e.target.value);
    },
    [phoneRepresenter],
  );
  const handleChangeRequirement = useCallback(
    (e) => {
      setHasUpdate(true);
      setRequirement(e.target.value);
    },
    [requirement],
  );
  const handleChangeBudget = useCallback(
    (e) => {
      setHasUpdate(true);
      setBudget(e.target.value);
    },
    [budget],
  );
  const handleChangeGoLiveDate = useCallback(
    (e) => {
      setHasUpdate(true);
      setGoLiveDate(e.target.value);
    },
    [goLiveDate],
  );
  const handleChangeIsPaymentCompleted = useCallback(
    (e) => {
      setHasUpdate(true);
      setIsPaymentCompleted(e.target.value === 'true' ? true : false);
    },
    [isPaymentCompleted],
  );
  const handleChangeNote = useCallback(
    (e) => {
      setHasUpdate(true);
      setNote(e.target.value);
    },
    [note],
  );
  const handleChangeEmail = useCallback(
    (e) => {
      setHasUpdate(true);
      setEmail(e.target.value);
    },
    [email],
  );
  return (
    <Box>
      <Grid container spacing={1}>
        {/* row 1 */}
        <Grid item xs={6} sm={3} md={3}>
          <TextInput
            required
            error={!code}
            helperText={!code && 'Vui lòng nhập Mã'}
            label="Mã"
            name="code"
            onChange={handleChangeCode}
            value={code}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <TextInput
            required
            error={!name}
            helperText={!name && 'Vui lòng nhập Khách hàng'}
            label="Khách hàng"
            name="name"
            onChange={handleChangeName}
            value={name}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={3}></Grid>
        {/* row 2 */}
        <Grid item xs={6} sm={3} md={3}>
          <TextInput
            required
            error={!taxCode}
            helperText={!taxCode && 'Vui lòng nhập Mã số thuế'}
            label="Mã số thuế"
            name="taxCode"
            onChange={handleChangeTaxCode}
            value={taxCode}
          />
        </Grid>
        <Grid item xs={6} sm={9} md={9}>
          <ArrayInput
            value={arrAddress}
            fullWidth
            onChange={handleChangeArrAddress}
            label="Địa chỉ"
            name="arrAddress"
          />
        </Grid>
        {/* row 3 */}
        <Grid item xs={6} sm={3} md={3}>
          <TextInput
            label="Loại hàng hóa"
            name="cargotype"
            onChange={handleChangeCargotype}
            value={cargotype}
          />
        </Grid>
        <Grid item xs={6} sm={9} md={9}>
          <ArrayInput
            value={arrPhone}
            fullWidth
            onChange={handleChangeArrPhone}
            label="Số điện thoại"
            name="arrAddress"
          />
        </Grid>
        {/* row 4 */}
        <Grid item xs={6} sm={3} md={3}>
          <TextInput
            label="Người đại diện"
            name="representer"
            onChange={handleChangeRepresenter}
            value={representer}
          />
        </Grid>
        <Grid item xs={6} sm={9} md={9}>
          <ArrayInput
            value={arrFax}
            fullWidth
            onChange={handleChangeArrFax}
            label="Ứng dụng liên hệ"
            name="arrAddress"
          />
        </Grid>
        {/* row 5 */}
        <Grid item xs={6} sm={3} md={3}>
          <TextInput
            label="Ngày sinh người đại diện"
            name="birthdayRepresenter"
            onChange={handleChangeBirthdayRepresenter}
            value={birthdayRepresenter}
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={3}>
          <TextInput
            label="Email Người đại diện"
            name="emailRepresenter"
            onChange={handleChangeEmailRepresenter}
            value={emailRepresenter}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={3}>
          <TextInput
            label="SĐT Người đại diện"
            name="phoneRepresenter"
            onChange={handleChangePhoneRepresenter}
            value={phoneRepresenter}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={3}>
          <TextInput
            label="Ngày go live"
            name="goLiveDate"
            onChange={handleChangeGoLiveDate}
            value={goLiveDate}
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        {/* row 6 */}
        <Grid item xs={6} sm={3} md={3}>
          <TextInput
            label="Nhu cầu"
            name="requirement"
            onChange={handleChangeRequirement}
            value={requirement}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={3}>
          <StyledTextFieldPrice
            label="Ngân sách"
            variant="outlined"
            type="text"
            size="small"
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
            value={budget}
            onChange={handleChangeBudget}
            // value={el?.price}
            // error={!el?.price}
            // disabled={disabledField}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={6}>
          <FormLabel id="rate-verification">Thanh toán:</FormLabel>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <RadioGroup
              onChange={handleChangeIsPaymentCompleted}
              value={isPaymentCompleted}
              row
              aria-labelledby="rate-verification"
              name="rateVerification"
              //   sx={{ justifyContent: 'flex-end' }}
            >
              <FormControlLabel value={false} control={<Radio />} label="Chưa thanh toán" />
              <FormControlLabel value={true} control={<Radio />} label="Đã thanh toán" />
            </RadioGroup>
          </Box>
        </Grid>
        {/* row 6 */}
        <Grid item xs={6} sm={6} md={6}>
          <TextInput label="Ghi chú" name="note" onChange={handleChangeNote} value={note} />
        </Grid>
        <Grid item xs={6} sm={3} md={3}>
          <TextInput label="Email" name="email" onChange={handleChangeEmail} value={email} />
        </Grid>
      </Grid>
      <Box
        sx={{
          marginTop: '20px',
          display: 'flex',
        }}
      >
        <Box
          sx={{
            marginLeft: 'auto',
          }}
        >
          <BtnRejectContract
            color="error"
            variant="contained"
            disabled={!hasUpdate}
            onClick={handleCancelUpdate}
          >
            Hủy Cập nhật
          </BtnRejectContract>
          <BtnApproveContract
            sx={{ marginRight: '15px' }}
            color="primary"
            variant="contained"
            disabled={!hasUpdate}
            onClick={handleUpdate}
          >
            Cập nhật
          </BtnApproveContract>
        </Box>
      </Box>
    </Box>
  );
};

export const BtnRejectContract = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '15px',
  margin: '0px 5px',
  //   border: '1px solid rgba(0, 0, 0, 0.4)',
  padding: '4px 15px',
  '.MuiButton-startIcon': {
    marginRight: '10px',
  },
}));
export const BtnApproveContract = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '15px',
  margin: '0px 5px',
  //   border: '1px solid rgba(0, 0, 0, 0.4)',
  padding: '4px 15px',
  '.MuiButton-startIcon': {
    marginRight: '10px',
  },
}));
const StyledTextFieldPrice = styled(TextField)(({ theme }) => ({
  marginTop: '8px',
  width: '100%',
}));
